import { db } from '@/firebase'
import { 
  collection, 
  addDoc, 
  getDocs,
  query,
  orderBy,
  doc,
  updateDoc,
  deleteDoc,
  serverTimestamp 
} from 'firebase/firestore'

/**
 * 상담 신청 저장 (통합)
 * @param {Object} data - 폼 데이터
 * @param {string} data.name - 성함
 * @param {string} data.phone - 연락처
 * @param {string} data.message - 상담내용
 * @param {string} source - 출처 (pc-floating, mobile, support-page 등)
 */
export const saveConsultation = async (data, source = 'unknown') => {
  try {
    const docRef = await addDoc(collection(db, 'consultations'), {
      name: data.name,
      phone: data.phone,
      message: data.message || '',
      source: source,
      status: 'pending',
      createdAt: serverTimestamp()
    })
    
    console.log('상담 신청 저장 완료:', docRef.id)
    return { success: true, id: docRef.id }
  } catch (error) {
    console.error('상담 신청 저장 실패:', error)
    return { success: false, error: error.message }
  }
}

/**
 * 모든 상담 신청 조회
 */
export const getConsultations = async () => {
  try {
    const q = query(
      collection(db, 'consultations'),
      orderBy('createdAt', 'desc')
    )
    const querySnapshot = await getDocs(q)
    
    const consultations = []
    querySnapshot.forEach((doc) => {
      consultations.push({
        id: doc.id,
        ...doc.data()
      })
    })
    
    return { success: true, data: consultations }
  } catch (error) {
    console.error('상담 목록 조회 실패:', error)
    return { success: false, error: error.message }
  }
}

/**
 * 상담 상태 업데이트
 * @param {string} id - 문서 ID
 * @param {string} status - 새로운 상태 (pending, completed, cancelled)
 */
export const updateConsultationStatus = async (id, status) => {
  try {
    const docRef = doc(db, 'consultations', id)
    await updateDoc(docRef, {
      status: status,
      updatedAt: serverTimestamp()
    })
    
    return { success: true }
  } catch (error) {
    console.error('상태 업데이트 실패:', error)
    return { success: false, error: error.message }
  }
}

/**
 * 상담 삭제
 * @param {string} id - 문서 ID
 */
export const deleteConsultation = async (id) => {
  try {
    await deleteDoc(doc(db, 'consultations', id))
    return { success: true }
  } catch (error) {
    console.error('삭제 실패:', error)
    return { success: false, error: error.message }
  }
}